import React from 'react';
import { Row, Col } from 'antd';
import resources from '../../resources';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';
import StatItem4 from '../BaseComponents/StatItem4';

class DigitalBusiness2024Content extends React.Component {
  render() {
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const t = languages[lang].DigitalBusiness2024Content;
    const {isMobile} = StoreManager.appState.thisApp.state

    return (
      <div style={{  lineHeight: 1.6 }}>
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 600 }}>{t.title}</h2>

        {/* Intro */}
        <div style={{ marginTop: 24 }}>
          {t.intro.map((p, i) => <p key={i}>{p}</p>)}
        </div>

        {/* Four Icon Cards */}
        <Row gutter={[12, 24]} style={{ marginTop: 32, marginBottom: 48 }}>
          {t.iconStats.map((item, index) => {
            const isLast = index === t.iconStats.length - 1;
            const isOddLength = t.iconStats.length % 2 === 1;
            const colMd = isLast && isOddLength ? 24 : 12;

            return (
              <Col xs={24} md={colMd} key={index}>
                <StatItem4
                  iconName={`DigitalBusinessIcon${index + 1}`}
                  value={item.value}
                  message1={item.text}
                />
              </Col>
            );
          })}
        </Row>


        {/* Global Expansion */}
        <div style={{ marginBottom: 24 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{t.globalTitle}</h4>
          {t.globalText.map((p, i) => <p key={i}>{p}</p>)}
          <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
            <Col xs={24} md={12}><img src={resources.images.DigitalBusinessImage1} alt="AI cloud" style={{ width: '100%', borderRadius: 12 }} /></Col>
            <Col xs={24} md={12}><img src={resources.images.DigitalBusinessImage2} alt="NVIDIA GPU" style={{ width: '100%', borderRadius: 12 }} /></Col>
          </Row>
        </div>

        {/* Enterprise Solutions */}
        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{t.enterpriseTitle}</h4>
          <p>{t.enterpriseIntro}</p>
          <p>{t.enterpriseList[0]}</p>
          <p>{t.enterpriseList[1]}</p>

          <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
             <li key={`1dhdh3`}>{t.enterpriseList[2]}</li>
             <li key={`1dhdh4`}>{t.enterpriseList[3]}</li>
          </ul>
          <p>{t.enterpriseList[4]}</p>
          <p>{t.enterpriseList[5]}</p>
          <div style={{ marginTop: 24 }}>
            <img src={resources.images.DigitalBusinessImage3} alt="TrueID" style={{ width: '100%', borderRadius: 12 }} />
          </div>
        </div>

        {/* Vision */}
        <div style={{ marginTop: 48 }}>
          {t.visionText.map((p, i) => <p key={i}>{p}</p>)}
        </div>

        {/* 2025 Vision */}
        <div style={{ marginTop: 48, marginBottom: 80 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{t.futureTitle}</h4>
          <p>{t.futureText}</p>
        </div>
      </div>
    );
  }
}

export default DigitalBusiness2024Content;
